import React, { useState } from 'react';
import { useOrders } from '../contexts/OrderContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Card } from '../components/ui/Card';
import { DEPOT_ZONES } from '../constants/zones';
import { Scan, CheckCircle } from 'lucide-react';
export function DepotReceptionPage() {
  const {
    orders,
    updateOrderStatus
  } = useOrders();
  const [orderId, setOrderId] = useState('');
  const [depotZone, setDepotZone] = useState('');
  const [scannedOrder, setScannedOrder] = useState<any>(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const handleScan = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setScannedOrder(null);
    const order = orders.find(o => o.id === orderId);
    if (!order) {
      setError('Commande introuvable');
      return;
    }
    if (order.status !== 'COLLECTEE') {
      setError(`Statut incorrect: ${order.status} (Attendu: COLLECTEE)`);
      return;
    }
    setScannedOrder(order);
  };
  const handleConfirm = async () => {
    if (!scannedOrder || !depotZone) return;
    try {
      await updateOrderStatus(scannedOrder.id, 'RECUE_DEPOT', `Réception dépôt - ${depotZone}`);
      setSuccess(`Commande ${scannedOrder.id} reçue avec succès dans ${depotZone}`);
      setOrderId('');
      setScannedOrder(null);
      setDepotZone('');
    } catch (err) {
      setError('Erreur lors de la mise à jour');
    }
  };
  return <div className="max-w-xl mx-auto space-y-6" data-id="element-397">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-398">Réception au Dépôt</h1>

      <Card data-id="element-399">
        <form onSubmit={handleScan} className="flex gap-4 items-end mb-6" data-id="element-400">
          <Input label="ID Commande (Scan)" value={orderId} onChange={e => setOrderId(e.target.value)} placeholder="CMD-..." autoFocus data-id="element-401" />
          <Button type="submit" className="mb-[2px]" data-id="element-402">
            <Scan className="w-4 h-4 mr-2" data-id="element-403" />
            Rechercher
          </Button>
        </form>

        {error && <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-4 text-sm" data-id="element-404">
            {error}
          </div>}

        {success && <div className="bg-green-50 text-green-600 p-4 rounded-lg mb-4 text-sm flex items-center" data-id="element-405">
            <CheckCircle className="w-4 h-4 mr-2" data-id="element-406" />
            {success}
          </div>}

        {scannedOrder && <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 space-y-4 animate-in fade-in slide-in-from-top-4" data-id="element-407">
            <div className="flex justify-between items-start" data-id="element-408">
              <div data-id="element-409">
                <h3 className="font-bold text-lg text-gray-900" data-id="element-410">
                  {scannedOrder.clientName}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-411">
                  {scannedOrder.type} (Qté: {scannedOrder.quantity})
                </p>
              </div>
              <div className="text-right" data-id="element-412">
                <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded" data-id="element-413">
                  {scannedOrder.status}
                </span>
              </div>
            </div>

            <div className="pt-4 border-t border-gray-200" data-id="element-414">
              <Select label="Zone de Dépôt (Obligatoire)" value={depotZone} onChange={e => setDepotZone(e.target.value)} options={DEPOT_ZONES.map(z => ({
            value: z,
            label: z
          }))} required data-id="element-415" />
            </div>

            <Button onClick={handleConfirm} fullWidth disabled={!depotZone} className="mt-4" data-id="element-416">
              Confirmer la Réception
            </Button>
          </div>}
      </Card>
    </div>;
}